import React, { useEffect } from "react";
import ProfileIcon from './ProfileIcon';
import follow_circle from "../../assets/follow_circle.png";


export default function FollowButtonProfilePic({ img }){
    return (
      <>
        <ProfileIcon img={img}></ProfileIcon>
        <img
          style={{
            position: "relative",
            top: -12,
            height: 25,
            width: 25,
            left: 13,
            marginBottom: 16,
            zIndex: 2,
          }}
          src={follow_circle}
        />
      </>
    );
  };